/** Canned exercise-variety guidance for onboarding + program editors. */
export const VARIETY_CANNED_RESPONSES = [
  "Low variety — same exercises, track progression.",
  "Moderate — stable main lifts, rotate accessories.",
  "High — frequent exercise swaps, same movement patterns.",
  "A/B split — slight variation between sessions.",
  "Unilateral alternation — swap bilateral and unilateral lifts each week.",
  "Pattern-only swaps — keep squat/hinge/push/pull, change the exercise.",
  "No back-to-back repeats — don't use the same exercise two sessions in a row.",
  "Block rotation — refresh the exercise pool every 3–4 weeks.",
] as const;

export type VarietyCannedResponse = (typeof VARIETY_CANNED_RESPONSES)[number];

export const VARIETY_CUSTOM_SELECT_VALUE = "__custom__";

export function isVarietyCannedResponse(value: string): value is VarietyCannedResponse {
  return (VARIETY_CANNED_RESPONSES as readonly string[]).includes(value);
}
